/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".power_off[_ngcontent-%COMP%]{background:0 0;outline:0;border:0;cursor:pointer}"];
export { styles as styles };
